import { client } from '@oysterjs/ais/api/client';
import {
  DeleteFeedbackDocument,
  DeleteFeedbackMutation,
  DeleteFeedbackMutationVariables,
  SubmitCallRatingDocument,
  SubmitCallRatingMutation,
  SubmitCallRatingMutationVariables,
  SubmitMessageRatingDocument,
  SubmitMessageRatingMutation,
  SubmitMessageRatingMutationVariables
} from '@oysterjs/ais/api/graphql';

export type SubmitMessageRatingInput = SubmitMessageRatingMutationVariables['input'];

export const submitMessageRating = async (input: SubmitMessageRatingInput) => {
  const { data } = await client.mutate<
    SubmitMessageRatingMutation,
    SubmitMessageRatingMutationVariables
  >({
    mutation: SubmitMessageRatingDocument,
    variables: { input }
  });

  return data?.submitMessageRating ?? null;
};

export type SubmitCallRatingInput = SubmitCallRatingMutationVariables['input'];

export const submitCallRating = async (input: SubmitCallRatingInput) => {
  const { data } = await client.mutate<SubmitCallRatingMutation, SubmitCallRatingMutationVariables>(
    {
      mutation: SubmitCallRatingDocument,
      variables: { input }
    }
  );

  return data?.submitCallRating ?? null;
};

export const deleteFeedback = async (id: string) => {
  const { data } = await client.mutate<DeleteFeedbackMutation, DeleteFeedbackMutationVariables>({
    mutation: DeleteFeedbackDocument,
    variables: { id }
  });

  return data?.deleteFeedback ?? null;
};
